{
  "layout": {
    "notFound": {
      "title": "找不到競賽",
      "description": "此競賽不存在，或您在其中沒有任何角色，兩者刻意回傳相同結果。"
    },
    "accessDenied": {
      "title": "無法進入這場競賽的管理工作區",
      "description": "你目前無法以此角色進入這場競賽。",
      "back": "前往你可以使用的頁面"
    },
    "loading": "載入中…",
    "pinned": "由管理員固定狀態",
    "adminGuide": "管理操作手冊",
    "sections": {
      "overview": "總覽",
      "categories": "類別",
      "rounds": "賽程輪次",
      "forms": "表單",
      "teams": "隊伍管理",
      "people": "成員與角色",
      "audit": "稽核紀錄",
      "submissions": "作品繳交",
      "judges": "評審",
      "judgingLoad": "審查進度",
      "rubrics": "評分規準",
      "results": "結果",
      "files": "檔案",
      "participants": "參賽者",
      "registrationData": "報名資料",
      "eligibilityData": "資格驗證資料",
      "exports": "匯出中心",
      "operationsDashboard": "營運儀表板",
      "eligibilityReviews": "資格驗證審核",
      "announcements": "公告",
      "manualScores": "手動輸入"
    },
    "navGroups": {
      "settings": "設定",
      "operations": "營運",
      "data": "資料",
      "review": "審查",
      "permissions": "權限",
      "governance": "治理"
    }
  },
  "operations": {
    "title": "營運儀表板",
    "description": "此刻整場競賽的營運狀況：報名、資格驗證、作品、評審進度。",
    "loading": "載入中…",
    "loadFailed": "無法載入營運資料。",
    "retry": "重試",
    "refresh": "重新整理",
    "notApplicable": "N/A",
    "updatedAt": "最後更新：{{time}}",
    "stage": {
      "registration": "報名期",
      "submission": "繳件期",
      "judging": "評審期",
      "results": "結果公布"
    },
    "settingsCta": "前往競賽設定總覽 →",
    "groups": {
      "registration": "報名",
      "participants": "參賽者",
      "eligibility": "資格驗證",
      "submission": "作品繳交",
      "judging": "評審"
    },
    "kpi": {
      "registration": {
        "teams": "報名隊伍",
        "complete": "完成報名",
        "incomplete": "未完成報名",
        "cancelled": "取消／退賽"
      },
      "participants": {
        "total": "參賽者總數"
      },
      "eligibility": {
        "required": "需要驗證人數",
        "submitted": "已提交資格證明",
        "pending": "審核中",
        "verified": "已通過",
        "rejected": "退回補件",
        "missing": "尚未提交",
        "expired": "已過期",
        "submissionRate": "資格證明提交完成率",
        "approvalRate": "資格驗證通過完成率"
      },
      "submission": {
        "required": "應繳作品",
        "submitted": "已提交作品",
        "draft": "草稿",
        "missing": "尚未提交"
      },
      "judging": {
        "judges": "評審總數",
        "accepted": "已接受邀請",
        "pendingInvite": "待接受邀請",
        "assignments": "評審任務",
        "completedAssignments": "已完成評分",
        "completionRate": "評分完成率"
      }
    },
    "needsAttention": {
      "title": "待處理事項",
      "empty": "目前沒有需要立即處理的項目。",
      "severity": {
        "critical": "嚴重",
        "warning": "警告",
        "info": "提醒"
      },
      "items": {
        "eligibilityPending": "{{count}} 位學生資格證明審核中",
        "eligibilityMissing": "{{count}} 位必要成員尚未提交資格證明",
        "eligibilityRejected": "{{count}} 位學生資格證明已退回，等待重新上傳",
        "eligibilityExpired": "{{count}} 位成員資格證明已過期",
        "registrationIncomplete": "{{count}} 隊尚未完成報名",
        "submissionMissing": "{{count}} 隊尚未繳交作品",
        "judgingPendingInvite": "{{count}} 位評審尚未接受邀請"
      }
    },
    "hiddenGroups": {
      "hide": "隱藏",
      "label": "已隱藏：",
      "show": "顯示"
    }
  },
  "list": {
    "title": "競賽",
    "description": "您參與的競賽。平台管理員可以看到所有競賽。",
    "new": "新增競賽",
    "newFromTemplate": "從範本建立",
    "newFromImport": "從 JSON 匯入",
    "loading": "載入中…",
    "loadError": "無法載入競賽清單。",
    "empty": {
      "title": "目前沒有競賽",
      "description": "您尚未擁有任何競賽角色，請聯絡管理員為您指派。"
    },
    "platformAdmin": "平台管理員",
    "cta": {
      "admin": "管理競賽 →",
      "participant": "進入競賽 →",
      "viewOnly": "查看競賽 →"
    },
    "filter": {
      "searchLabel": "依名稱搜尋",
      "searchPlaceholder": "搜尋競賽名稱…",
      "statusLabel": "狀態",
      "statusAll": "全部狀態",
      "roleLabel": "我的角色",
      "roleAll": "全部角色",
      "noMatches": "沒有符合目前篩選條件的競賽。",
      "resultCount": "共 {{count}} 場競賽",
      "clear": "清除篩選"
    }
  },
  "categories": {
    "title": "類別",
    "description": "此競賽下的分組，例如高中組與大專組。名稱僅需在同一競賽內不重複。",
    "loading": "載入中…",
    "empty": "目前尚無類別。",
    "archived": "已封存",
    "unlimitedTeams": "不限隊伍數",
    "upToTeams": "最多 {{count}} 支隊伍",
    "archive": "封存",
    "add": {
      "title": "新增類別",
      "description": "類別會被封存而非刪除，因此曾參照它的隊伍仍可正常顯示。",
      "name": "名稱",
      "capacity": "名額上限（選填）",
      "failed": "無法新增類別。",
      "submit": "新增類別"
    }
  },
  "rounds": {
    "title": "賽程輪次",
    "description": "競賽預設為單輪賽制。新增決賽輪次即可啟用「初賽書面審查 → 入圍 → 決賽」的雙階段賽制。",
    "loading": "載入中…",
    "roundOrder": "第 {{order}} 輪",
    "name": "名稱",
    "status": "狀態",
    "none": "無",
    "submissionForm": "提交表單",
    "defaultRubric": "預設評分表",
    "save": "儲存輪次",
    "saving": "儲存中…",
    "saved": "輪次已儲存。",
    "saveFailed": "無法儲存輪次。",
    "statusBackwardWarning": "您正將輪次狀態從「{{from}}」倒退為「{{to}}」，這可能連動影響報名／繳件／評審視窗的開放判斷。請確認這是您要的變更。",
    "statusBackwardConfirm": "確認回退並儲存",
    "key": {
      "preliminary": "初賽",
      "final": "決賽"
    },
    "statusValue": {
      "draft": "草稿",
      "open": "開放中",
      "judging": "評審中",
      "closed": "已結束"
    },
    "schedule": {
      "registrationStart": "報名開始",
      "registrationEnd": "報名截止",
      "submissionStart": "繳件開始",
      "submissionEnd": "繳件截止",
      "judgingStart": "評審開始",
      "judgingEnd": "評審結束",
      "resultPublish": "結果公布"
    },
    "add": {
      "title": "新增輪次",
      "description": "一場競賽最多可有兩輪：初賽與決賽。",
      "key": "輪次類型",
      "name": "名稱",
      "failed": "無法新增輪次。",
      "submit": "新增輪次"
    },
    "manual": {
      "modeLabel": "評分輸入方式",
      "mode": {
        "judge_only": "僅評審評分",
        "staff_only": "僅工作人員輸入",
        "judge_and_staff": "評審＋工作人員輸入"
      },
      "modeHelp": {
        "judge_only": "只有評審依評分表評分，與目前的計算方式相同（預設）。",
        "staff_only": "不由評審評分，成績完全來自工作人員輸入的欄位。",
        "judge_and_staff": "以評審平均分為基礎，再加上工作人員輸入的加分與扣分。"
      },
      "fieldsTitle": "手動輸入欄位",
      "fieldsHelp": "設定工作人員要輸入的欄位、分數範圍與計分方式。已有輸入資料的欄位只能改名，不能刪除或改範圍。",
      "fieldsEmpty": "尚未設定欄位。",
      "range": "範圍 {{min}} 至 {{max}}",
      "effect": {
        "add": "加分",
        "deduct": "扣分",
        "record_only": "僅記錄"
      },
      "effectHelp": {
        "add": "輸入值會加進總分。",
        "deduct": "輸入值（正數）會從總分扣除。",
        "record_only": "只留存紀錄，不影響總分。"
      },
      "deleteField": "刪除",
      "deleteFailed": "無法刪除欄位。",
      "fieldName": "欄位名稱",
      "minScore": "最低分",
      "maxScore": "最高分",
      "effectLabel": "計分方式",
      "rangeInvalid": "請輸入有效的分數範圍，最高分不得低於最低分。",
      "addField": "新增欄位",
      "addFailed": "無法新增欄位。"
    }
  },
  "forms": {
    "title": "表單",
    "description": "發布後再編輯表單會複製出新的草稿版本，而不會變更目前上線中的內容。",
    "createFailed": "無法建立表單。",
    "loading": "載入中…",
    "notCreated": "尚未建立。",
    "unpublished": "尚未發布",
    "live": "第 {{version}} 版上線中",
    "addOne": "新增{{type}}",
    "singletonActiveExists": "此競賽已有一份上線中的{{type}}，請先封存後再新增。",
    "namePrompt": "請為此表單命名（例如：初賽報名表單），以便在賽程輪次中辨識",
    "namePlaceholder": "表單名稱",
    "createSubmit": "建立",
    "createCancel": "取消",
    "rename": "重新命名",
    "renameSave": "儲存",
    "renameCancel": "取消",
    "renameFailed": "無法更新表單名稱。",
    "summary": {
      "fields": "{{count}} 個欄位",
      "required": "{{count}} 個必填",
      "fileFields": "{{count}} 個檔案欄位",
      "unboundRound": "未綁定輪次"
    }
  },
  "judges": {
    "autoDistribute": {
      "title": "自動平均分配",
      "description": "依每位評審目前的工作量與類別，為已送出的作品建議一組平均的指派；會略過利益衝突與已存在的指派。先預覽，確認後才會建立。",
      "round": "賽程輪次",
      "rubric": "評分規準",
      "perSubmission": "每件作品的評審人數",
      "preview": "預覽分配",
      "summary": "預計建立 {{planned}} 筆指派，涵蓋 {{submissions}} 件作品",
      "judge": "評審",
      "load": "工作量（目前 + 新增）",
      "loadChange": "{{before}} + {{added}}",
      "underCovered": "有 {{count}} 件作品因可用評審不足（衝突或人數不夠）而無法達到目標人數，請另外邀請評審或手動指派。",
      "nothing": "沒有需要新增的指派。",
      "apply": "套用分配",
      "error": "無法計算分配，請確認輪次與評分規準。",
      "dialogTitle": "建立自動分配的指派",
      "dialogTarget": "{{count}} 筆指派",
      "dialogScope": "依預覽結果為評審建立指派，並各記錄一筆稽核；建立前會再次檢查利益衝突與重複。",
      "dialogImpact": "評審會在幾分鐘後收到一封彙整的新指派通知；已建立的指派可在「作品指派」逐筆調整或取消。",
      "dialogConfirm": "確認建立指派",
      "dialogSuccess": "已建立 {{created}} 筆指派，{{skipped}} 筆因衝突或重複而略過。"
    },
    "title": "評審",
    "description": "管理評審、邀請與作品指派；評審角色需先在「成員與角色」設定。",
    "loading": "載入中…",
    "workload_other": "工作量：{{count}} 件進行中的指派",
    "workloadBadge_other": "{{count}} 件",
    "inviteCta": "＋ 邀請評審",
    "summary": {
      "judges": "評審 {{count}}",
      "pendingInvitations": "待接受邀請 {{count}}",
      "activeAssignments": "進行中指派 {{count}}",
      "unassignedSubmissions": "尚未指派作品 {{count}}",
      "conflicts": "已申報迴避 {{count}}"
    },
    "tabs": {
      "list": "評審名單",
      "invite": "邀請管理",
      "assign": "作品指派",
      "conflicts": "利益衝突"
    },
    "list": {
      "searchLabel": "搜尋評審",
      "searchPlaceholder": "依姓名、Email 或專長搜尋…",
      "filter": {
        "all": "全部",
        "has": "有工作量",
        "none": "無工作量"
      },
      "empty": "目前沒有評審。",
      "emptyTitle": "尚未邀請評審",
      "emptyDescription": "要開始作品指派，請先新增或邀請評審。",
      "noMatches": "沒有符合條件的評審。",
      "noExpertise": "—",
      "columns": {
        "name": "評審",
        "email": "Email",
        "expertise": "專長",
        "workload": "工作量"
      }
    },
    "invite": {
      "title": "邀請評審",
      "description": "若對方尚無帳號，系統會自動建立帳號並寄送一次性臨時登入資訊；若已有帳號，會沿用原帳號密碼，不會另外寄送新密碼。管理員全程不會看到密碼。",
      "emailPlaceholder": "評審 Email",
      "submit": "送出邀請",
      "sent": "邀請已送出。",
      "failed": "無法送出邀請。",
      "listTitle": "邀請紀錄",
      "listEmpty": "尚無任何邀請紀錄。",
      "columns": {
        "email": "Email",
        "status": "狀態",
        "expiresAt": "到期時間",
        "actions": "操作"
      },
      "declineReason": "婉拒原因：{{reason}}",
      "status": {
        "pending": "待接受",
        "declined": "已婉拒",
        "accepted": "已接受",
        "cancelled": "已取消",
        "expired": "已過期"
      },
      "resend": "重新發送",
      "resent": "已重新發送。",
      "resendFailed": "無法重新發送。",
      "cancel": "取消邀請",
      "cancelled": "邀請已取消。",
      "cancelFailed": "無法取消邀請。"
    },
    "assign": {
      "title": "手動指派評審",
      "description": "勾選作品與評審（可複選），並依指定的評分標準版本評分。系統會建立每個作品 × 評審的組合，利益衝突與重複指派會自動略過並提示原因。",
      "submission": "作品（可複選）",
      "submissionPlaceholder": "請選擇作品…",
      "searchSubmissions": "搜尋作品",
      "searchSubmissionsPlaceholder": "依團隊或組別搜尋…",
      "selectedSubmissions": "已選 {{count}} 件",
      "noSubmissions": "目前沒有可指派的已提交作品。",
      "judge": "評審（可複選）",
      "judgePlaceholder": "請選擇評審…",
      "searchJudges": "搜尋評審",
      "searchJudgesPlaceholder": "依姓名或 Email 搜尋…",
      "selectedJudges": "已選 {{count}} 位",
      "judgeWorkload_other": "{{count}} 件進行中",
      "noJudges": "此競賽尚無任何具評審角色的成員。",
      "noMatches": "沒有符合條件的項目。",
      "rubric": "評分標準",
      "rubricPlaceholder": "請選擇評分標準…",
      "noRubrics": "尚未設定評分標準。",
      "submit": "批次建立指派",
      "created": "指派已建立。",
      "failed": "無法建立指派。",
      "willCreate": "{{submissions}} 件作品 × {{judges}} 位評審，將建立 {{total}} 筆指派",
      "batchResult": "已建立 {{created}} 筆指派，略過 {{skipped}} 筆。",
      "skipReason": {
        "duplicate": "重複指派",
        "conflict_of_interest": "利益衝突",
        "not_a_judge": "非評審身分",
        "team_disqualified": "隊伍已取消資格"
      }
    },
    "assignments": {
      "title": "目前的指派",
      "description": "此競賽中所有評審與作品的指派關係。",
      "loading": "載入中…",
      "empty": "尚無任何指派。",
      "searchLabel": "搜尋指派",
      "searchPlaceholder": "依團隊、組別或評審搜尋…",
      "noMatches": "沒有符合條件的指派。",
      "columns": {
        "team": "團隊",
        "category": "組別",
        "round": "輪次",
        "judge": "評審",
        "rubric": "評分標準版本",
        "status": "狀態",
        "createdAt": "指派時間",
        "actions": "操作"
      },
      "judgeLabel": "評審",
      "rubricLabel": "評分標準",
      "edit": "編輯",
      "cancel": "取消",
      "save": "儲存",
      "saved": "指派已更新。",
      "editFailed": "無法更新指派，可能已重複或有利益衝突。",
      "editOnlyActive": "只能編輯狀態為「進行中」的指派。",
      "reassignConfirmTitle": "確認變更評審指派",
      "reassignImpact": "此作品的評分將改由「{{to}}」負責，原指派評審「{{from}}」將不再對此作品評分。",
      "reassignSuccess": "指派已更新。",
      "teamDisqualified": "已取消資格",
      "disqualifiedBanner": "目前有 {{count}} 筆進行中的指派屬於已取消資格的隊伍，這些作品的分數不會被計入。",
      "cancelDisqualified": {
        "action": "取消失格隊伍的評審指派",
        "dialogTitle": "取消失格隊伍的評審指派",
        "dialogTarget": "{{count}} 筆進行中的指派",
        "dialogScope": "已取消資格隊伍作品上所有尚未送出的評審指派。已送出的評分與評分紀錄不受影響。",
        "dialogImpact": "評審會收到一封彙整的「評審指派已調整」通知（不含原因）；之後可重新指派。",
        "dialogConfirm": "取消這些指派",
        "dialogSuccess": "已取消這些指派。"
      }
    },
    "conflicts": {
      "empty": "此競賽目前沒有任何已申報的利益衝突案件。",
      "error": "無法載入利益衝突清單。",
      "columns": {
        "judge": "評審",
        "team": "隊伍",
        "reason": "原因",
        "source": "來源",
        "declaredAt": "申報時間"
      },
      "source": {
        "self_declared": "評審自行申報",
        "admin_defined": "主辦方設定"
      }
    }
  },
  "judgingLoad": {
    "reminders": {
      "title": "提醒評審完成評分",
      "auto": {
        "toggle": "截止前自動提醒評審",
        "help": "開啟後，系統會在每一輪審查截止前的指定時數，自動寄一次提醒信給仍有未送出評分的評審。預設關閉。",
        "hours": "提前幾小時",
        "save": "儲存自動提醒設定",
        "saved": "已儲存自動提醒設定。",
        "error": "儲存失敗，提前時數需介於 1 到 336 小時。",
        "sent": "已自動提醒 {{count}} 個審查輪次。"
      },
      "description": "{{count}} 位評審尚有未完成的評分。",
      "none": "目前沒有評審有待處理的評分。",
      "progress": "{{pending}} / {{total}} 件未完成",
      "cta": "寄送提醒給未完成的評審",
      "dialogTitle": "寄送評審進度提醒",
      "dialogTarget": "{{count}} 位評審",
      "dialogScope": "寄給每位仍有未送出評分的評審，信中列出其未完成件數與最近的審查截止時間，並附上前往評審任務的連結。",
      "dialogImpact": "信件由系統寄出並記錄一筆稽核，不會修改任何評分或指派；已申報利益迴避的作品不計入。",
      "dialogConfirm": "寄送提醒",
      "dialogSuccess": "已寄出 {{count}} 封提醒。",
      "previewTitle": "信件預覽（以第一位評審為例）"
    },
    "title": "審查進度",
    "description": "每位評審的指派負載、完成進度與利益衝突重疊情形，及早發現需要處理的異常。",
    "loading": "載入中…",
    "table": {
      "title": "評審負載表",
      "description": "每位評審的指派、完成、待評與已申報衝突數。",
      "error": "無法載入評審負載表。",
      "empty": "此競賽尚無評審。",
      "noActivityYet": "尚無活動",
      "heuristicNote": "「工作量過重」指進行中指派數超過競賽平均值的 {{multiplier}} 倍；「近期無活動」指有進行中指派但無任何完成紀錄，且最近 {{days}} 天內無評分更新。以上僅為操作提示，並非對特定評審的評斷。",
      "columns": {
        "judge": "評審",
        "status": "狀態",
        "assigned": "已指派",
        "completed": "已完成",
        "pending": "待評",
        "coi": "利益衝突",
        "lastActivity": "最後活動",
        "flags": "提示"
      }
    },
    "flags": {
      "overloaded": "工作量過重",
      "under_assigned": "指派不足",
      "no_activity": "近期無活動"
    },
    "coi": {
      "title": "利益衝突重疊警示",
      "description": "評審已申報迴避、但仍持有相同作品或隊伍的進行中指派——迴避應已排除該指派，此為需要處理的資料異常。",
      "error": "無法載入利益衝突清單。",
      "empty": "目前沒有利益衝突與指派重疊的情形。",
      "columns": {
        "actions": "操作"
      },
      "reassignCta": "重新指派",
      "cancelOnlyCta": "僅取消指派",
      "selectJudgeLabel": "選擇新評審",
      "selectJudgePlaceholder": "請選擇評審…",
      "reassignSubmit": "確認重新指派",
      "reassignFailed": "無法重新指派，請確認新評審未對此作品申報利益衝突。",
      "confirmPrompt": "此操作將取消該評審對此作品的進行中指派，之後該作品會透過既有的「尚未指派」機制顯示需要重新指派。",
      "confirmCta": "確認取消指派",
      "cancelCta": "取消",
      "cancelReason": "透過審查進度頁面，解除 {{judge}} 的利益衝突與指派重疊。",
      "adjustFailed": "無法取消指派。"
    }
  },
  "savedViews": {
    "selectLabel": "已儲存的檢視",
    "selectPlaceholder": "選擇已儲存的檢視…",
    "apply": "套用",
    "delete": "刪除",
    "saveCurrentCta": "另存目前篩選為檢視",
    "nameLabel": "檢視名稱",
    "namePlaceholder": "檢視名稱…",
    "saveSubmit": "儲存",
    "saveCancel": "取消"
  },
  "teams": {
    "title": "隊伍管理",
    "description": "查看此競賽中所有隊伍與隊員，移除隊員、轉移隊長，或建立邀請連結以手動新增隊員。所有操作皆會寫入稽核紀錄。",
    "searchPlaceholder": "搜尋隊伍名稱",
    "loading": "載入中…",
    "forbidden": "您沒有權限查看此競賽的隊伍。",
    "empty": "目前尚無隊伍。",
    "filterEmpty": "沒有符合目前篩選條件的隊伍。",
    "filters": {
      "statusPlaceholder": "報名狀態",
      "statusAll": "全部",
      "statusComplete": "已完成報名",
      "statusIncomplete": "尚未完成報名",
      "statusCancelled": "已取消退賽"
    },
    "columns": {
      "name": "隊伍名稱",
      "code": "隊伍代碼",
      "status": "狀態",
      "category": "類別",
      "leader": "隊長",
      "members": "成員",
      "registration": "報名",
      "eligibilitySubmitted": "資格證明",
      "eligibilityApproved": "資格通過",
      "submission": "作品",
      "judging": "審查",
      "attention": "注意事項",
      "updatedAt": "更新時間"
    },
    "registration": {
      "complete": "已完成",
      "incomplete": "尚未完成"
    },
    "submissionState": {
      "missing": "尚未提交",
      "draft": "草稿",
      "submitted": "已提交"
    },
    "attention": {
      "registrationIncomplete": "尚未完成報名",
      "eligibilityMissing": "資格證明尚未提交",
      "eligibilityRejected": "資格證明遭退回",
      "eligibilityExpired": "資格證明已過期",
      "submissionMissing": "尚未繳交作品",
      "noJudgeAssignment": "尚未指派評審"
    },
    "memberExpand": {
      "count": "{{count}} 位成員"
    },
    "reminders": {
      "cta": "傳送報名提醒",
      "dialogTitle": "傳送報名提醒",
      "dialogTarget": "所有尚未完成報名的隊伍隊長",
      "dialogScope": "本競賽",
      "dialogImpact": "系統將寄送一封提醒信給每一支尚未完成報名的隊伍隊長，提醒他們儘快完成報名資料填寫。已完成報名或已取消退賽的隊伍不會收到信件。",
      "dialogConfirm": "傳送提醒",
      "dialogSuccess": "已傳送提醒信給 {{count}} 支隊伍。",
      "previewTitle": "信件預覽",
      "previewLoading": "載入預覽中…",
      "previewSample": "以隊伍「{{name}}」為範例；每位隊長的信件會寫上自己的隊名。這是純文字內容，實際信件另有 HTML 排版。",
      "previewError": "無法載入信件預覽。"
    },
    "pagination": {
      "previous": "上一頁",
      "next": "下一頁",
      "pageInfo": "第 {{from}}–{{to}} 筆，共 {{total}} 筆"
    },
    "detail": {
      "title": "隊伍詳情",
      "back": "返回隊伍列表",
      "loading": "載入中…",
      "notFound": "找不到此隊伍。"
    },
    "members": {
      "title": "隊員",
      "remove": "移除",
      "removing": "移除中…",
      "removed": "已移除隊員。",
      "removeFailed": "無法移除隊員。",
      "removeConfirmTitle": "移除成員？",
      "removeScope": "移除後將立即生效。",
      "removeImpact": "移除後，{{name}} 將不再是此團隊成員。若要再次加入，需要重新接受有效邀請。",
      "removeSuccess": "已移除 {{name}}。",
      "transferLeadership": "轉移隊長",
      "newLeader": "新隊長",
      "selectMember": "請選擇隊員…",
      "reason": "原因",
      "transferSubmit": "轉移隊長",
      "transferring": "轉移中…",
      "transferred": "已轉移隊長。",
      "transferFailed": "無法轉移隊長。"
    },
    "invitations": {
      "title": "邀請連結",
      "description": "v1 手動流程：產生一次性邀請連結，交給要加入的隊員；沒有直接新增隊員的端點。",
      "createOneTime": "建立一次性邀請",
      "creating": "建立中…",
      "linkReady": "邀請連結已建立：",
      "copy": "複製邀請連結",
      "copyAria": "複製邀請連結",
      "copied": "✓ 已複製",
      "copyFailed": "無法自動複製邀請連結，請手動複製。",
      "createFailed": "無法建立邀請。",
      "show": "顯示邀請清單",
      "hide": "隱藏邀請清單",
      "empty": "目前沒有邀請紀錄。",
      "expires": "到期時間",
      "revoke": "撤銷"
    }
  },
  "eligibilityReviews": {
    "title": "資格驗證審核",
    "description": "審核參賽者提交的資格證明。此頁與「資格驗證資料」共用同一份資料，但聚焦於待處理的審核工作。",
    "loading": "載入中…",
    "forbidden": "您沒有權限審核資格驗證。"
  },
  "people": {
    "title": "成員與角色",
    "description": "角色僅適用於此競賽，同一帳號在不同競賽中可擁有不同角色。",
    "loading": "載入中…",
    "forbidden": "您沒有權限查看此處的角色成員。",
    "empty": "目前尚無角色授權。",
    "noMatches": "沒有符合條件的成員。",
    "grantCta": "＋ 授予角色",
    "summary": {
      "total": "{{count}} 位成員",
      "roleCount": "{{label}} {{count}}"
    },
    "list": {
      "searchLabel": "搜尋成員",
      "searchPlaceholder": "依姓名或 Email 搜尋…",
      "roleFilterLabel": "角色（可複選，找出同時具備多個角色的成員）",
      "roleFilterAll": "全部",
      "columns": {
        "member": "成員",
        "email": "Email",
        "roles": "角色",
        "actions": "操作"
      },
      "manageRoles": "管理角色"
    },
    "revoke": "撤銷",
    "revokeFailed": "無法撤銷。",
    "grant": {
      "title": "授予角色",
      "description": "以電子郵件授予，該帳號須至少登入過一次。",
      "email": "電子郵件",
      "existingRoles": "目前角色：{{roles}}",
      "role": "角色",
      "failed": "無法授予角色。",
      "submit": "授予角色",
      "granted": "已授予角色。",
      "cancel": "取消"
    },
    "manage": {
      "title": "管理角色",
      "revoke": "撤銷",
      "revokeConfirm": "確定要撤銷「{{role}}」角色嗎？",
      "confirmRevoke": "確認撤銷",
      "cancel": "取消",
      "close": "關閉"
    },
    "tabs": {
      "label": "成員與角色分頁",
      "members": "成員名單",
      "eligibility": "資格驗證"
    }
  },
  "audit": {
    "title": "稽核紀錄",
    "description": "查看競賽的重要設定與操作歷史。紀錄不可修改或刪除。",
    "search": {
      "label": "搜尋紀錄",
      "placeholder": "搜尋姓名、Email、作品、隊伍或操作…"
    },
    "categoryFilter": {
      "label": "事件類型",
      "all": "全部",
      "competitionSetup": "競賽設定",
      "peopleAndRoles": "成員與角色",
      "team": "隊伍",
      "submission": "作品繳交",
      "file": "檔案",
      "judging": "評審",
      "scoring": "評分",
      "result": "結果",
      "form": "表單"
    },
    "dateFilter": {
      "label": "時間",
      "today": "今天",
      "last7Days": "最近 7 天",
      "last30Days": "最近 30 天",
      "custom": "自訂",
      "from": "起始時間",
      "to": "結束時間"
    },
    "advanced": {
      "toggle": "進階：事件代碼",
      "placeholder": "事件代碼，例如 form_version.publish"
    },
    "loading": "載入中…",
    "loadingMore": "載入更多中…",
    "loadMore": "載入更多",
    "forbidden": "您沒有權限讀取此競賽的稽核紀錄。",
    "empty": "沒有符合的紀錄。",
    "deletedAccount": "已刪除的帳號",
    "rawEventCode": "事件代碼",
    "target": "對象",
    "reason": "原因：{{reason}}",
    "viewChanges": "檢視變更內容",
    "diff": {
      "field": "欄位",
      "before": "變更前",
      "after": "變更後",
      "empty": "此筆紀錄沒有可比較的欄位資料。",
      "viewRaw": "查看原始資料"
    }
  },
  "submissions": {
    "title": "作品繳交",
    "description": "此競賽中所有團隊的作品繳交紀錄。",
    "filters": {
      "statusPlaceholder": "所有狀態",
      "categoryPlaceholder": "所有類別",
      "teamPlaceholder": "團隊 ID",
      "roundPlaceholder": "所有輪次"
    },
    "loading": "載入中…",
    "forbidden": "您沒有權限查看跨團隊的作品繳交紀錄。",
    "empty": "沒有符合的作品繳交紀錄。",
    "notSubmitted": "尚未提交",
    "columns": {
      "team": "團隊",
      "category": "類別",
      "status": "狀態",
      "submittedAt": "提交時間",
      "round": "輪次"
    },
    "pagination": {
      "previous": "上一頁",
      "next": "下一頁",
      "pageInfo": "第 {{from}}–{{to}} 筆，共 {{total}} 筆"
    },
    "detail": {
      "title": "作品繳交詳情",
      "back": "返回作品繳交列表",
      "loading": "載入中…",
      "notFound": "找不到此作品繳交紀錄。",
      "team": "所屬團隊",
      "files": {
        "title": "上傳檔案",
        "empty": "尚無上傳檔案。",
        "uploadedBy": "上傳者：{{name}}"
      },
      "answers": "填答內容",
      "noAnswers": "尚無填答紀錄。",
      "versions": {
        "title": "已提交版本",
        "description": "每次提交時擷取的不可變快照，版本建立後其內容永不變更。",
        "empty": "尚無已提交的版本。",
        "version": "版本 {{number}}"
      },
      "scores": {
        "matrix": {
          "title": "分項比較",
          "criterion": "評分項目",
          "gap": "差距",
          "gapValue": "相差 {{gap}}",
          "weight": "（{{weight}}%）"
        },
        "spread": {
          "title": "評審分數差異大。",
          "detail": "最高 {{highest}}、最低 {{lowest}}，相差 {{spread}} 分。計算結果前建議確認是否有評分誤差；必要時可請評審覆核（重新開放）。"
        },
        "title": "評審評分",
        "description": "僅顯示各評審的審查意見與總分，個人評審備註對主辦單位保持不可見。",
        "loading": "載入評分中…",
        "empty": "尚無評審完成此作品的評分。",
        "statusBadge": {
          "draft": "草稿",
          "submitted": "已送出",
          "locked": "已送出",
          "reopened": "已重新開放"
        },
        "totalScore": "總分 {{total}} / 100",
        "totalScorePending": "尚未計算總分",
        "reviewComment": "審查意見",
        "reviewCommentEmpty": "（未填寫）",
        "reopen": {
          "action": "重新開放",
          "dialogTitle": "重新開放評分",
          "dialogScope": "僅此評審對此作品的分數",
          "dialogImpact": "評審將可重新修改並送出分數，原始分數與本次理由將保留於稽核紀錄。",
          "dialogConfirm": "重新開放評分",
          "dialogSuccess": "評分已重新開放，評審現在可以修改並重新送出。"
        }
      },
      "actions": {
        "title": "作品繳交操作",
        "lock": {
          "action": "鎖定",
          "dialogTitle": "鎖定作品繳交",
          "dialogImpact": "作品繳交狀態將轉為「已鎖定」，本次操作與理由將保留於稽核紀錄。",
          "dialogConfirm": "鎖定作品繳交",
          "dialogSuccess": "已鎖定此作品繳交，主辦方可依情況重新解鎖。"
        },
        "unlock": {
          "action": "解鎖",
          "dialogTitle": "解鎖作品繳交",
          "dialogImpact": "作品繳交狀態將轉為「準備中」，團隊可重新編輯並再次正式提交，本次操作與理由將保留於稽核紀錄。",
          "dialogConfirm": "解鎖作品繳交",
          "dialogSuccess": "已解鎖此作品繳交，團隊可重新編輯並再次提交。"
        },
        "withdraw": {
          "action": "撤回",
          "dialogTitle": "撤回作品繳交",
          "dialogImpact": "作品繳交狀態將轉為「已撤回」，本次操作與理由將保留於稽核紀錄。",
          "dialogConfirm": "撤回作品繳交",
          "dialogSuccess": "已撤回此作品繳交。"
        },
        "disqualify": {
          "action": "取消資格",
          "dialogTitle": "取消作品繳交資格",
          "dialogImpact": "作品繳交狀態將轉為「已取消資格」，整支隊伍在所有輪次都不能再提交或修改，結果計算也會排除該隊，並自動取消該隊尚未送出的評審指派（已送出的評分保留）；隊伍會收到通知信（不含原因），本次操作與理由將保留於稽核紀錄，並可由競賽管理員復原。",
          "dialogConfirm": "取消資格",
          "dialogSuccess": "已取消此作品繳交的資格。"
        },
        "returnForCorrection": {
          "action": "退回修正",
          "dialogTitle": "退回作品繳交修正",
          "dialogImpact": "作品繳交狀態將轉為「準備中」，團隊將收到通知信說明需要修改的原因，可重新編輯並再次正式提交，本次操作與理由將保留於稽核紀錄。",
          "dialogConfirm": "退回修正",
          "dialogSuccess": "已將此作品繳交退回修正，團隊將收到通知信說明需要修改的原因。"
        },
        "dialogScope": "僅此作品繳交紀錄",
        "reinstate": {
          "action": "復原取消資格",
          "dialogTitle": "復原取消資格",
          "dialogImpact": "作品會回到取消資格前的狀態（已提交或已鎖定，不會回到草稿），隊伍可再繼續參賽並收到通知信（不含原因）。不會自動重算結果，也不會自動恢復已取消的評審指派；原因與操作會保留於稽核紀錄。",
          "dialogConfirm": "復原取消資格",
          "dialogSuccess": "已復原取消資格。",
          "recalculateNote": "此輪次已有計算過的結果，請到「結果審查」重新計算；若有被取消的評審指派，需另行重新指派。"
        }
      },
      "round": "輪次：{{name}}"
    }
  },
  "files": {
    "title": "檔案",
    "description": "此競賽中所有作品繳交的上傳檔案。",
    "filters": {
      "statusPlaceholder": "所有狀態",
      "submissionPlaceholder": "作品繳交 ID"
    },
    "loading": "載入中…",
    "forbidden": "您沒有權限查看跨團隊的檔案。",
    "empty": "沒有符合的檔案。",
    "columns": {
      "filename": "檔案",
      "team": "團隊",
      "type": "類型",
      "size": "大小",
      "status": "狀態",
      "actions": "操作"
    },
    "pagination": {
      "previous": "上一頁",
      "next": "下一頁",
      "pageInfo": "第 {{from}}–{{to}} 筆，共 {{total}} 筆"
    }
  },
  "overview": {
    "loading": "載入中…",
    "loadFailed": "無法載入此競賽。",
    "saved": "已儲存。",
    "operationsCta": {
      "description": "想知道競賽現在的營運狀況（報名、資格驗證、作品、評審進度）？",
      "label": "前往營運儀表板 →"
    },
    "moreActions": {
      "label": "更多操作",
      "export": "匯出競賽設定",
      "clone": "複製競賽",
      "saveAsTemplate": "儲存為範本"
    },
    "basic": {
      "title": "競賽基本資訊",
      "slug": "平台網址",
      "name": "名稱",
      "officialWebsiteUrl": "官方競賽網站",
      "shortDescription": "簡短介紹",
      "saveFailed": "無法儲存。",
      "saving": "儲存中…",
      "save": "儲存變更",
      "cancel": "取消",
      "year": "年度",
      "timezone": "時區",
      "notSet": "未設定",
      "editTitle": "編輯競賽基本資訊",
      "platformPath": "平台內部競賽路徑：",
      "openWebsite": "開啟網站 ↗",
      "slugChangeWarning": "修改平台網址後，原競賽網址可能失效。",
      "slugConflict": "此平台網址已被其他競賽使用。",
      "slugInvalid": "平台網址格式不正確，僅能使用小寫英數字與連字號。",
      "nameRequired": "請輸入名稱。",
      "officialWebsiteUrlInvalid": "請輸入有效的 https 網址。",
      "yearInvalid": "請輸入有效的年度。",
      "savedMessage": "競賽基本資訊已更新",
      "logo": {
        "label": "競賽 Logo",
        "notSet": "尚未設定 Logo",
        "noLogo": "尚未設定",
        "altWithName": "{{name}} Logo",
        "previewAlt": "Logo 預覽",
        "upload": "上傳 Logo",
        "replace": "更換 Logo",
        "remove": "移除",
        "hint": "建議使用正方形圖片，PNG／JPG／WebP，至少 256×256 px，最大 2 MB。",
        "aspectWarning": "建議使用正方形圖片；目前圖片比例非 1:1，顯示時可能會裁切。",
        "uploading": "上傳中…（{{percent}}%）",
        "finalizing": "處理中…",
        "errors": {
          "fileType": "僅接受 PNG、JPG 或 WebP 格式的圖片。",
          "tooLarge": "檔案大小不得超過 2 MB。",
          "tooSmall": "圖片尺寸至少需為 {{min}}×{{min}} px。",
          "unreadable": "無法讀取這個圖片檔案，請確認檔案未毀損後再試一次。",
          "generic": "無法上傳 Logo，請稍後再試。",
          "genericWithDetail": "無法上傳 Logo：{{detail}}"
        }
      }
    },
    "schedule": {
      "title": "排程",
      "registrationStart": "報名開始",
      "registrationEnd": "報名截止",
      "submissionStart": "作品繳交開始",
      "submissionEnd": "作品繳交截止",
      "judgingStart": "評審開始",
      "judgingEnd": "評審結束",
      "resultPublish": "結果發布",
      "saveFailed": "無法儲存排程。",
      "saving": "儲存中…",
      "save": "儲存排程",
      "timezoneNotice": "所有競賽時間皆以 {{timezone}} 顯示。",
      "utcNotice": "系統內部以 UTC 儲存。",
      "editCta": "編輯排程",
      "editTitle": "編輯排程",
      "notSet": "尚未設定",
      "orderingWarning": "作品繳交截止時間晚於評審開始時間，請確認排程順序是否正確。",
      "orderingWarningRound": "{{roundName}}：作品繳交截止時間晚於評審開始時間，請確認排程順序是否正確。",
      "crossRoundWarning": "{{toRound}}的繳件／報名開始時間早於{{fromRound}}的結果公布時間，請確認輪次排程順序是否正確。",
      "manageRoundsCta": "管理輪次排程",
      "multiRoundNotice": "此競賽使用多輪賽制，各階段時間請於「賽程輪次」管理。",
      "goToRounds": "前往修正 →",
      "phases": {
        "registration": "報名",
        "submission": "作品繳交",
        "judging": "評審",
        "resultPublish": "結果發布"
      }
    },
    "eligibility": {
      "title": "資格條件",
      "description": "隊伍人數與參賽規則。",
      "minTeamSize": "隊伍最小人數",
      "maxTeamSize": "隊伍最大人數",
      "allowTeacher": "隊伍可包含指導老師",
      "requireTeacher": "須有指導老師",
      "allowMultipleSubmissions": "隊伍可多次繳交作品",
      "anonymousJudging": "匿名評審",
      "saveFailed": "無法儲存資格條件。",
      "saving": "儲存中…",
      "save": "儲存資格條件",
      "editTitle": "編輯資格條件",
      "groups": {
        "team": "隊伍規則",
        "submission": "投稿規則",
        "judging": "評審規則"
      },
      "yes": "是",
      "no": "否",
      "on": "開啟",
      "off": "關閉"
    },
    "readiness": {
      "status": {
        "ready": "已就緒",
        "pending": "尚未開始",
        "unavailable": "平台尚未提供"
      },
      "items": {
        "basicInformation": "基本資訊",
        "schedule": "排程",
        "eligibility": "資格條件",
        "categories": "類別",
        "dynamicForm": "動態表單",
        "rubric": "評分規準",
        "judgingSetup": "評審設定",
        "publicPage": "公開頁面",
        "previewAndPublish": "發布"
      },
      "actionNeeded": {
        "title": "需要處理",
        "description": "僅列出尚待處理的設定項目。",
        "allClear": "目前沒有需要立即處理的設定。"
      },
      "collapsedSummary": "準備狀態 {{ready}} / {{total}} 已完成"
    },
    "status": {
      "title": "狀態",
      "pinnedStatus": "固定狀態",
      "followSchedule": "依排程自動決定",
      "reason": "原因（必填）",
      "applyFailed": "無法變更狀態。",
      "riskNotice": "覆寫狀態會改變整場競賽對外呈現的狀態，套用前請先確認此操作正確。",
      "scheduleImplies": "目前排程判定",
      "actualStatus": "目前實際狀態",
      "overrideActive": "管理員覆寫中",
      "review": "檢視變更",
      "cancelOverride": "取消覆寫",
      "confirmMessage": "將競賽從「{{from}}」手動切換為「{{to}}」。",
      "confirmDetail": "排程仍會持續計算，但不再決定實際狀態。請確認此操作符合目前競賽流程。",
      "confirmApply": "確認套用",
      "applying": "套用中…"
    },
    "settings": {
      "title": "設定",
      "description": "公開聯絡資訊與頁面顯示設定。",
      "contactEmail": "聯絡信箱",
      "publicPageLive": "公開競賽頁面已上線",
      "reviewCommentRequired": "評審必須填寫「審查意見」才能送出評分",
      "saveFailed": "無法儲存設定。",
      "save": "儲存設定",
      "editTitle": "編輯設定",
      "notSet": "未設定",
      "live": "已上線",
      "offline": "尚未上線",
      "saving": "儲存中…",
      "eligibilityText": "參賽資格",
      "submissionRequirementsText": "作品繳交規定",
      "judgingCriteriaText": "評選標準",
      "prizesText": "獎項",
      "organizerContactText": "主辦單位聯絡方式",
      "faq": {
        "title": "常見問答",
        "question": "問題",
        "answer": "答案",
        "remove": "移除",
        "add": "新增常見問答"
      }
    },
    "discoveryCategories": {
      "title": "探索分類",
      "description": "選擇本競賽要出現在公開探索頁的哪些分類篩選中。與本競賽自己的組別（下方「分類」分頁）是不同的東西，互不影響。",
      "saveFailed": "無法儲存分類。",
      "save": "儲存分類",
      "none": "尚未選擇任何分類。",
      "add": "＋ 新增分類"
    },
    "milestone": {
      "title": "下一個里程碑",
      "roundPhase": "{{roundName}} · {{phase}}",
      "daysUntil_other": "還有 {{count}} 天"
    },
    "studentEligibilityPolicy": {
      "title": "學生資格驗證",
      "description": "設定本競賽是否要求參賽學生驗證在學身分，以及審核規則。",
      "editTitle": "編輯學生資格驗證設定",
      "disabledSummaryTitle": "目前未啟用",
      "disabledSummaryBody": "參賽學生目前不需要提供在學資格證明。",
      "enabledStatus": "已啟用",
      "scopeSummaryLabel": "驗證對象",
      "proofTypesSummaryLabel": "接受證明",
      "reviewSummaryLabel": "審核方式",
      "reviewManual": "人工審核",
      "reviewNotRequired": "免審核",
      "pendingSummaryLabel": "審核期間",
      "pendingAllowed": "允許先送出報名",
      "pendingNotAllowed": "需審核通過後才可送出報名",
      "validitySummaryLabel": "證明有效期限",
      "validityDaysSummary": "核准後 {{days}} 天",
      "enabledToggle": "啟用學生資格驗證",
      "enabledToggleHint": "啟用後，參賽學生須依設定提供在學身分證明。",
      "scope": "驗證適用範圍",
      "scopeOptions": {
        "all_student_members": "所有學生成員",
        "all_participating_members": "所有參賽成員（不含指導老師）",
        "team_leader_only": "僅隊長",
        "minimum_verified_members": "至少 N 位成員"
      },
      "scopeNotSet": "尚未選擇",
      "minimumVerifiedMembers": "最低驗證人數",
      "minimumVerifiedMembersUnit": "人",
      "proofTypesSectionTitle": "接受的證明文件",
      "proofTypeOptions": {
        "enrollment_certificate": "在學證明書",
        "student_id": "學生證",
        "other_approved": "其他核可文件"
      },
      "proofTypesRequiredError": "請至少選擇一種可接受的證明文件。",
      "reviewSectionTitle": "審核方式",
      "reviewRequired": "須人工審核",
      "allowSubmitWhilePending": "審核中允許送出報名",
      "validitySectionTitle": "證明有效期限",
      "validityUnlimitedOption": "不限制有效期限",
      "validityLimitedOption": "核准後有效",
      "validityDaysUnit": "天",
      "proofValidityDays": "證明有效天數",
      "unlimitedDays": "不限",
      "notSet": "未設定",
      "cancel": "取消",
      "save": "儲存變更",
      "saving": "儲存中…",
      "saveFailed": "儲存失敗，請稍後再試。",
      "loadFailed": "無法載入學生資格驗證設定。"
    }
  },
  "builder": {
    "title": "新增競賽",
    "intro": "競賽會以草稿狀態建立，排程設定完成前參與者皆無法看見。排程、資格條件與其餘設定，皆可在建立後於競賽的「總覽」頁籤設定。",
    "formCard": {
      "title": "基本資訊",
      "description": "之後皆可在競賽的「總覽」頁籤中修改。"
    },
    "fields": {
      "name": "名稱",
      "slug": "網址代稱",
      "slugHint": "以連字號分隔的小寫單字，須為平台唯一。",
      "year": "年度",
      "timezone": "顯示時區",
      "shortDescription": "簡短介紹（選填）"
    },
    "createFailed": "無法建立競賽。",
    "creating": "建立中…",
    "create": "建立競賽"
  },
  "dateStrategy": {
    "title": "日期策略",
    "clear": "清除",
    "clearHint": "清除所有日期，建立後請重新設定排程。",
    "preserve": "保留",
    "preserveHint": "保留原本的日期；若日期已過期，送出後會顯示警告。",
    "shift": "平移",
    "shiftHint": "以下方指定的錨點日期，將整組時程按比例平移到新的時間點。",
    "anchorDate": "錨點日期",
    "anchorDateHint": "所有日期將以此日期為基準整體平移，時間先後順序不會改變。",
    "warningsTitle": "警告",
    "continue": "繼續"
  },
  "clone": {
    "title": "複製競賽",
    "intro": "從「{{name}}」複製競賽設定，送出新競賽申請。",
    "formCard": {
      "title": "新競賽資訊",
      "description": "複製後的競賽為全新草稿，不含任何參賽者、團隊、作品、評審或分數資料。需經平台管理員審核通過後才會正式建立，與一般建立競賽相同。"
    },
    "fields": {
      "name": "名稱",
      "slug": "網址代稱",
      "year": "年度"
    },
    "options": {
      "title": "複製選項",
      "includePublicPageText": "包含公開頁面文字",
      "includeJudgingSettings": "包含評審設定（評分表）",
      "dateStrategyNote": "所有日期將被清除，複製後請重新設定排程。"
    },
    "excludedNotice": "不會複製：參賽者、團隊、作品、評審指派、分數、結果、稽核紀錄。",
    "failed": "送出失敗，請稍後再試。",
    "submitting": "送出中…",
    "submit": "送出申請"
  },
  "saveAsTemplate": {
    "title": "儲存為範本",
    "intro": "將「{{name}}」目前的設定儲存為可重複使用的範本。",
    "formCard": {
      "title": "範本資訊",
      "description": "範本只包含競賽設定，不含任何參賽者、團隊、作品、評審或分數資料。"
    },
    "fields": {
      "name": "範本名稱",
      "description": "說明（選填）",
      "visibility": "可見範圍"
    },
    "visibility": {
      "private": "私人（僅我可見）",
      "platform": "平台共用（所有主辦方可見）"
    },
    "success": "範本已儲存。",
    "failed": "儲存失敗，請稍後再試。",
    "submitting": "儲存中…",
    "submit": "儲存為範本"
  },
  "createFromTemplate": {
    "title": "從範本建立競賽",
    "intro": "選擇一個範本，建立新的草稿競賽。",
    "loading": "載入中…",
    "loadError": "無法載入範本清單。",
    "empty": "目前沒有可用的範本。",
    "visibilityLabel": "可見範圍：{{visibility}}",
    "formCard": {
      "title": "新競賽資訊",
      "description": "從範本建立的競賽為全新草稿，所有日期將被清除。需經平台管理員審核通過後才會正式建立，與一般建立競賽相同。"
    },
    "fields": {
      "name": "名稱",
      "slug": "網址代稱",
      "year": "年度"
    },
    "failed": "送出失敗，請稍後再試。",
    "submitting": "送出中…",
    "submit": "送出申請"
  },
  "import": {
    "title": "從 JSON 匯入競賽",
    "intro": "貼上先前匯出的 .napaicp.json 競賽設定內容，送出新競賽申請。",
    "fileCard": {
      "title": "競賽設定 JSON",
      "description": "僅接受 JSON 純文字，不接受壓縮檔或執行檔。"
    },
    "fields": {
      "fileContents": "JSON 內容",
      "fileContentsHint": "貼上 .napaicp.json 檔案的完整內容。",
      "name": "名稱",
      "slug": "網址代稱",
      "year": "年度"
    },
    "validate": "驗證",
    "validating": "驗證中…",
    "validateFailed": "驗證失敗，請稍後再試。",
    "preflight": {
      "title": "驗證結果",
      "sourceName": "來源競賽名稱",
      "schemaVersion": "格式版本",
      "status": "狀態",
      "ready": "可以建立",
      "blocked": "無法建立",
      "unknown": "未知",
      "warningsTitle": "警告",
      "blockingTitle": "阻擋錯誤"
    },
    "excludedNotice": "不會匯入：參賽者、團隊、作品、評審指派、分數、結果、稽核紀錄、任何密碼或金鑰欄位。需經平台管理員審核通過後才會正式建立，與一般建立競賽相同。",
    "create": "送出申請",
    "creating": "送出中…",
    "createFailed": "送出失敗，請稍後再試。"
  },
  "formEditor": {
    "notFound": {
      "title": "找不到表單",
      "description": "此表單不存在，或您在此競賽中沒有任何角色。"
    },
    "loading": "載入中…",
    "versionLive": "第 {{version}} 版上線中",
    "draftPending": "草稿待發布",
    "publishing": "發布中…",
    "publish": "發布",
    "viewingPublished": "您正在檢視已發布版本，編輯欄位會建立新的草稿版本，不會變更參與者目前看到的內容。",
    "draftNotice": "正在編輯第 {{draft}} 版草稿 · 參賽者目前仍看到第 {{live}} 版。",
    "draftNoticeUnpublished": "正在編輯第 {{draft}} 版草稿 · 此表單尚未發布，參賽者看不到此表單。",
    "preview": "預覽表單",
    "previewTitle": "參賽者預覽",
    "previewDescription": "顯示您目前編輯版本的實際欄位設定。可以自行選填以檢查條件欄位的顯示，不會送出或儲存任何資料。",
    "previewEmpty": "目前尚無欄位可預覽。",
    "tabs": {
      "fields": "欄位設計",
      "settings": "表單設定",
      "versions": "版本紀錄"
    },
    "settings": {
      "title": "表單設定",
      "description": "顯示名稱與說明，供管理員在挑選此表單（例如綁定輪次）時辨識。",
      "name": "名稱",
      "descriptionLabel": "說明（選填）",
      "save": "儲存",
      "saving": "儲存中…",
      "saveFailed": "無法儲存表單設定。"
    },
    "fields": {
      "title": "欄位",
      "description": "拖曳以排序。每個欄位可設定類型、必填、驗證規則與顯示條件。",
      "loading": "載入中…",
      "empty": "目前尚無欄位。",
      "addField": "新增欄位",
      "reorder": "調整順序：{{label}}",
      "moveUp": "上移：{{label}}",
      "moveDown": "下移：{{label}}",
      "reorderFailed": "排序儲存失敗，已還原為原本順序，請再試一次。",
      "required": "必填",
      "conditional": "條件顯示",
      "keyLabel": "代碼",
      "edit": "編輯",
      "delete": "刪除",
      "editTitle": "編輯欄位",
      "addTitle": "新增欄位",
      "advanced": "進階設定：代碼 `{{key}}`、類型 `{{type}}`",
      "deleteConfirmTitle": "確認刪除欄位",
      "deleteScope": "此表單的目前草稿版本",
      "deleteImpact": "刪除後，此欄位將從表單中移除；已收集的作答資料仍保留於歷史提交紀錄中，但不會再顯示於新的表單版本。",
      "deleteSuccess": "欄位已刪除。",
      "deleteFailed": "無法刪除欄位。"
    },
    "versions": {
      "title": "版本紀錄",
      "description": "已發布版本不會被就地修改──發布後的每次變更都會產生新版本，因此綁定舊版本的繳交資料仍能正確顯示。",
      "empty": "目前尚無版本。",
      "version": "第 {{number}} 版"
    },
    "form": {
      "key": "代碼",
      "type": "類型",
      "label": "標籤",
      "description": "說明（選填）",
      "required": "必填",
      "placeholder": "提示文字（選填）",
      "urlSuggestion": {
        "title": "建議的欄位說明（網址欄位）",
        "text": "請提供評審可直接開啟的連結。影片請使用 YouTube（不公開）或 Vimeo；雲端硬碟（如 Google Drive）請將分享權限設為「知道連結的任何人都能檢視」，並在評審結束前不要修改或撤銷。若為匿名評審，請勿在內容或分享帳號中出現隊名、校名或可辨識身分的資訊。",
        "apply": "套用建議文字"
      },
      "sectionLabel": "所屬區塊（選填）",
      "sectionLabelPlaceholder": "例如：提案簡報",
      "sectionLabelHint": "填入完全相同名稱的欄位，會在參賽者的作品工作區顯示為同一個區塊標題。留空表示這個欄位維持獨立。",
      "minLength": "最短長度",
      "maxLength": "最長長度",
      "pattern": "格式（正規表示式，選填）",
      "min": "最小值",
      "max": "最大值",
      "allowedExtensions": "允許的副檔名（以逗號分隔）",
      "fileUploadUnavailable": "檔案上傳功能尚未開放，此處僅供設定欄位。",
      "saving": "儲存中…",
      "saveField": "儲存欄位",
      "cancel": "取消"
    },
    "options": {
      "title": "選項",
      "value": "值",
      "label": "標籤",
      "remove": "移除",
      "add": "新增選項"
    },
    "visibility": {
      "toggle": "僅在符合條件時顯示此欄位",
      "matchAll": "符合所有條件",
      "matchAny": "符合任一條件",
      "fieldPlaceholder": "欄位…",
      "equals": "等於",
      "notEquals": "不等於",
      "valuePlaceholder": "值（true、false 或文字）",
      "remove": "移除",
      "addCondition": "新增條件"
    }
  },
  "eligibilityReview": {
    "title": "資格驗證",
    "description": "審核參賽學生的在學證明，通過或退回。",
    "loading": "載入中…",
    "forbidden": "您沒有權限查看資格驗證。",
    "empty": "目前沒有需要審核的成員。",
    "noMatches": "沒有符合篩選條件的成員。",
    "review": "審核",
    "summary": {
      "verified": "已通過",
      "pending": "待審核",
      "rejected": "未通過",
      "missingNote": "「未提交」人數需比對隊伍必要成員名單才能計算，目前資格驗證 API 未提供彙總，暫不顯示。"
    },
    "filters": {
      "statusPlaceholder": "全部狀態",
      "teamPlaceholder": "依隊伍 ID 篩選",
      "searchPlaceholder": "依姓名、Email 或學校搜尋…"
    },
    "columns": {
      "member": "成員",
      "team": "隊伍",
      "school": "學校",
      "proof": "證明",
      "status": "狀態",
      "updatedAt": "更新時間",
      "actions": "操作"
    },
    "proof": {
      "submitted": "已提交",
      "notSubmitted": "未提交"
    },
    "pagination": {
      "pageInfo": "顯示 {{from}}–{{to}}，共 {{total}} 筆",
      "previous": "上一頁",
      "next": "下一頁"
    },
    "drawer": {
      "noTeam": "尚無隊伍",
      "notSet": "未提供",
      "school": "學校",
      "department": "系所",
      "proofTitle": "在學證明",
      "noProof": "尚未上傳在學證明。",
      "decisionLabel": "審核結果",
      "decisionVerified": "通過",
      "decisionRejected": "未通過",
      "reasonLabel": "原因（未通過時必填）",
      "rejectNotice": "系統會以 Email 通知該學生，內容包含你填寫的原因，請留意措辭。",
      "reasonRequired": "退回時必須填寫原因。",
      "submitting": "送出中…",
      "confirm": "確認審核",
      "success": "審核已送出。",
      "failed": "審核送出失敗，請稍後再試。"
    }
  },
  "participants": {
    "title": "參賽者",
    "description": "本競賽所有隊長與隊員 — 與工作人員／管理／評審等角色分開（請見「人員與角色」）。",
    "loading": "載入中…",
    "loadFailed": "無法載入參賽者資料。",
    "empty": "目前尚無參賽者。",
    "noMatches": "沒有符合篩選條件的參賽者。",
    "notSet": "未提供",
    "summary": {
      "total": "參賽者",
      "teams": "隊伍",
      "leaders": "隊長",
      "members": "隊員",
      "verified": "已通過",
      "pending": "審核中",
      "rejected": "已退回",
      "missing": "尚未提交"
    },
    "filters": {
      "searchPlaceholder": "搜尋姓名、Email、學校…",
      "teamPlaceholder": "全部隊伍",
      "categoryPlaceholder": "全部類別",
      "eligibilityPlaceholder": "全部資格狀態",
      "registrationPlaceholder": "全部報名狀態",
      "sortPlaceholder": "排序",
      "sortDefault": "排序：姓名（預設）",
      "sortName": "排序：姓名",
      "sortUpdatedAt": "排序：最近活動"
    },
    "columns": {
      "name": "姓名",
      "team": "隊伍",
      "teamRole": "隊伍角色",
      "category": "類別",
      "school": "學校",
      "department": "科系",
      "eligibility": "資格驗證",
      "registration": "報名狀態",
      "updatedAt": "最近活動"
    },
    "teamRole": {
      "leader": "隊長",
      "member": "隊員"
    },
    "registrationStatus": {
      "complete": "已完成",
      "incomplete": "未完成"
    },
    "pagination": {
      "pageInfo": "顯示 {{from}}–{{to}}，共 {{total}} 筆",
      "previous": "上一頁",
      "next": "下一頁"
    }
  },
  "registrationData": {
    "title": "報名資料",
    "description": "所有隊伍的報名表填答狀態，僅供檢視；報名完成度不受資格驗證狀態影響。",
    "needsUpdate": {
      "title": "需補填的報名資料",
      "description": "已送出報名，但已儲存的答案不符合目前表單的學生，共 {{count}} 位。",
      "noTeam": "尚無團隊",
      "missing": "尚需補填：",
      "cta": "傳送補填提醒",
      "dialogTitle": "傳送報名資料補填提醒",
      "dialogTarget": "{{count}} 位需補填報名資料的學生本人",
      "dialogScope": "本競賽",
      "dialogImpact": "系統將寄送一封 Email 給每一位需補填的學生本人，說明尚需補填的欄位並附上補填連結。不會寄給隊長或教師，也不會代為填寫或修改任何報名資料。",
      "dialogConfirm": "傳送提醒",
      "dialogSuccess": "已傳送補填提醒給 {{count}} 位學生。",
      "testCta": "寄測試信給我自己",
      "testSent": "測試信已寄到你的帳號信箱，未寄給任何學生。",
      "testError": "測試信寄送失敗，請稍後再試。",
      "previewTitle": "信件預覽",
      "previewLoading": "載入預覽中…",
      "previewSample": "以「{{name}}」的資料為範例；每位學生的信件會列出他自己缺少的欄位。",
      "previewError": "無法載入信件預覽。"
    },
    "loading": "載入中…",
    "forbidden": "您沒有權限查看報名資料。",
    "empty": "目前沒有隊伍。",
    "noMatches": "沒有符合篩選條件的隊伍。",
    "filters": {
      "teamPlaceholder": "依隊伍 ID 篩選",
      "completedPlaceholder": "全部完成狀態",
      "completedTrue": "已完成",
      "completedFalse": "未完成",
      "searchPlaceholder": "依隊伍名稱、隊長姓名或 Email 搜尋…"
    },
    "columns": {
      "team": "隊伍",
      "leader": "隊長",
      "formVersion": "表單版本",
      "completed": "完成狀態",
      "updatedAt": "最後修改時間",
      "actions": "操作"
    },
    "completed": {
      "true": "已完成",
      "false": "未完成"
    },
    "noVersion": "尚無使用中的報名表",
    "viewAnswers": "查看填答內容",
    "pagination": {
      "pageInfo": "顯示 {{from}}–{{to}}，共 {{total}} 筆",
      "previous": "上一頁",
      "next": "下一頁"
    },
    "detail": {
      "title": "報名表填答內容",
      "loading": "載入中…",
      "notFound": "此隊伍尚未填答目前使用中的報名表。",
      "failed": "無法載入填答內容。",
      "formVersion": "表單版本 v{{version}}",
      "submittedAt": "首次送出：{{time}}",
      "updatedAt": "最後修改：{{time}}",
      "close": "關閉"
    }
  },
  "eligibilityData": {
    "title": "資格驗證資料",
    "description": "資格驗證的唯讀資料檢視，與審核工作台使用完全相同的資料來源。審核／退回操作請至資格驗證審核頁面。",
    "loading": "載入中…",
    "forbidden": "您沒有權限查看資格驗證資料。",
    "empty": "目前沒有資格驗證紀錄。",
    "noMatches": "沒有符合篩選條件的成員。",
    "filters": {
      "statusPlaceholder": "全部狀態",
      "teamPlaceholder": "依隊伍 ID 篩選",
      "searchPlaceholder": "依姓名、Email 或學校搜尋…"
    },
    "columns": {
      "member": "成員",
      "team": "隊伍",
      "school": "學校",
      "proofType": "證明類型",
      "status": "有效狀態",
      "currentVersion": "目前版本",
      "updatedAt": "更新時間",
      "reviewer": "審核者",
      "rejectionReason": "退回原因",
      "actions": "操作"
    },
    "noProof": "尚未提交",
    "filePurged": "檔案已依保存政策清除",
    "notSet": "未提供",
    "reviewLink": "前往審核工作台",
    "history": {
      "title": "歷史版本",
      "empty": "沒有先前版本。",
      "purged": "（檔案已依保存政策清除）"
    },
    "pagination": {
      "pageInfo": "顯示 {{from}}–{{to}}，共 {{total}} 筆",
      "previous": "上一頁",
      "next": "下一頁"
    }
  },
  "exportCenter": {
    "title": "匯出中心",
    "description": "本競賽的伺服端 CSV/XLSX 報表，支援欄位選擇、篩選匯出，並保留完整匯出稽核紀錄。",
    "columnsLabel": "欄位",
    "applyFilters": "套用目前篩選條件",
    "scope": {
      "loading": "計算匯出筆數中…",
      "failed": "無法計算匯出筆數。",
      "willExport": "將匯出 {{count}} 筆",
      "currentFilters": "目前篩選：{{filters}}",
      "noFilters": "目前篩選：無"
    },
    "downloadCsv": "下載 CSV",
    "downloadXlsx": "下載 XLSX",
    "downloading": "下載中…",
    "reports": {
      "teams": "隊伍",
      "submissions": "作品",
      "participants": "參賽者",
      "eligibility": "資格驗證",
      "registration": "報名資料",
      "judging": "評審",
      "scores": "評分與審查意見"
    },
    "columns": {
      "teams": {
        "name": "隊伍名稱",
        "code": "代碼",
        "status": "狀態",
        "category": "類別",
        "leader": "隊長",
        "createdAt": "建立時間"
      },
      "submissions": {
        "id": "作品 ID",
        "team": "隊伍",
        "status": "狀態",
        "submittedAt": "送出時間",
        "createdAt": "建立時間"
      },
      "participants": {
        "name": "姓名",
        "email": "Email",
        "team": "隊伍",
        "teamRole": "隊伍角色",
        "category": "類別",
        "school": "學校",
        "department": "系所",
        "eligibilityStatus": "資格驗證狀態",
        "registrationStatus": "報名狀態"
      },
      "eligibility": {
        "member": "成員",
        "email": "Email",
        "team": "隊伍",
        "school": "學校",
        "proofType": "證明類型",
        "effectiveStatus": "有效狀態",
        "updatedAt": "更新時間"
      },
      "registration": {
        "team": "隊伍",
        "leader": "隊長",
        "formVersion": "表單版本",
        "completionStatus": "完成狀態",
        "lastModified": "最後修改時間"
      },
      "judging": {
        "judge": "評審",
        "email": "Email",
        "invitationStatus": "邀請狀態",
        "assignmentCount": "指派件數",
        "completedCount": "完成件數"
      },
      "scores": {
        "round": "輪次",
        "category": "類別",
        "team": "隊伍",
        "submissionId": "作品 ID",
        "judge": "評審",
        "status": "狀態",
        "totalScore": "總分",
        "criteria": "各項分數",
        "reviewComment": "審查意見",
        "submittedAt": "送出時間"
      }
    },
    "filters": {
      "status": "狀態",
      "teamId": "隊伍 ID",
      "search": "搜尋",
      "completed": "完成狀態",
      "completedTrue": "已完成",
      "completedFalse": "未完成"
    },
    "errors": {
      "noColumns": "請至少選擇一個欄位。",
      "failed": "匯出失敗。"
    },
    "history": {
      "title": "匯出紀錄",
      "description": "本競賽的所有匯出呼叫紀錄，僅供檢視。",
      "filterPlaceholder": "全部報表類型",
      "loading": "載入中…",
      "failed": "無法載入匯出紀錄。",
      "empty": "尚無匯出紀錄。",
      "noFilters": "未套用篩選條件",
      "systemActor": "系統",
      "columns": {
        "time": "時間",
        "actor": "操作者",
        "reportKind": "報表",
        "filters": "篩選條件",
        "rowCount": "筆數"
      }
    }
  },
  "globalSearch": {
    "placeholder": "搜尋隊伍、參賽者、作品、評審…",
    "loading": "搜尋中…",
    "error": "搜尋失敗，請再試一次。",
    "noResults": "沒有符合的結果。",
    "groups": {
      "teams": "隊伍",
      "participants": "參賽者",
      "submissions": "作品",
      "judges": "評審"
    },
    "status": {
      "registration": {
        "complete": "報名完成",
        "incomplete": "報名未完成",
        "cancelled": "已取消"
      },
      "judgeAccepted": "邀請已接受"
    }
  },
  "announcements": {
    "loading": "載入中…",
    "forbidden": "您沒有權限管理公告。",
    "description": "公告會顯示在競賽公開頁與參賽者的「競賽資訊」頁，也可以選擇同時以 Email 通知。",
    "audience": {
      "all": "全部（含訪客）",
      "students": "參賽者",
      "judges": "評審"
    },
    "form": {
      "createTitle": "新增公告",
      "editTitle": "編輯公告",
      "title": "標題",
      "body": "內容",
      "bodyHint": "純文字。換行會保留，網址會自動變成連結。",
      "audience": "顯示對象（網站）",
      "alsoEmail": "同時寄 Email 通知",
      "preview": "預覽",
      "publish": "發布公告",
      "publishAndEmail": "發布並寄送 Email",
      "save": "儲存變更",
      "saved": "已儲存。",
      "error": "儲存失敗，請稍後再試。",
      "testEmail": "寄測試信給我自己",
      "testSent": "測試信已寄到你的帳號信箱，未寄給任何收件人。",
      "testError": "測試信寄送失敗，請稍後再試。"
    },
    "preview": {
      "title": "公告預覽",
      "untitled": "（尚未輸入標題）"
    },
    "recipients": {
      "title": "Email 收件人",
      "roles": {
        "student": "學生",
        "teacher": "教師",
        "judge": "評審"
      },
      "narrowHint": "以下條件只會縮小學生與教師的範圍，不影響評審。",
      "categories": "依類別",
      "rounds": "依輪次（第一輪為所有隊伍，後續輪次為已晉級的隊伍）",
      "answerField": "依報名欄位篩選",
      "answerFieldNone": "不依報名欄位篩選",
      "pickRole": "請至少選擇一種收件人角色。",
      "counting": "計算收件人數中…",
      "count": "預計寄送：{{count}} 位收件人",
      "noneToEmail": "目前沒有符合條件的收件人，無法寄送 Email。"
    },
    "list": {
      "title": "已發布的公告",
      "empty": "尚無公告。",
      "emailed": "已寄送 Email：{{count}} 位",
      "notEmailed": "尚未寄送 Email",
      "edit": "編輯",
      "editAria": "編輯 {{title}}",
      "email": "寄送 Email",
      "emailAria": "寄送 Email：{{title}}",
      "delete": "刪除",
      "deleteAria": "刪除 {{title}}"
    },
    "emailDialog": {
      "title": "發布公告並寄送 Email",
      "existingTitle": "寄送公告 Email",
      "target": "{{count}} 位收件人",
      "existingTarget": "公告「{{title}}」，共 {{count}} 位收件人",
      "scope": "本競賽",
      "impact": "系統會將這則公告的標題與內容以 Email 寄給上述收件人（信末註明為競賽官方通知）。寄出後無法收回。",
      "resendImpact": "這則公告已經寄送過 Email。再次寄送會讓收件人收到重複的信件。",
      "confirm": "確認寄送",
      "success": "已寄送 Email 給 {{count}} 位收件人。"
    },
    "deleteDialog": {
      "title": "刪除公告",
      "scope": "本競賽",
      "impact": "公告會從網站移除，已寄出的 Email 無法收回。",
      "confirm": "刪除公告",
      "success": "已刪除。"
    },
    "emailPreview": {
      "title": "信件預覽",
      "loading": "載入預覽中…",
      "hint": "這是收件人會收到的純文字內容，實際信件另有 HTML 排版。要修改內容，請修改公告標題或內文。",
      "error": "無法載入信件預覽。"
    }
  },
  "manualScores": {
    "title": "手動輸入評分",
    "description": "為已開放手動輸入的輪次，輸入各參賽作品的欄位數值。",
    "loading": "載入中…",
    "noPermission": "您沒有輸入手動評分的權限。",
    "noRounds": "目前沒有開放工作人員輸入的輪次。",
    "round": "輪次",
    "loadFailed": "無法載入輸入表。",
    "noFields": "此輪次尚未設定手動輸入欄位，請洽主辦方。",
    "noSubmissions": "此輪次目前沒有可輸入的作品。",
    "readonly": {
      "mode_disallows_staff": "此輪次不開放工作人員輸入。",
      "round_not_open": "輪次須為「開放中」或「評審中」才能輸入。",
      "results_locked": "此輪次的結果已鎖定或公布，無法再修改輸入資料。"
    },
    "lastUpdated": "{{name}} 於 {{time}} 更新",
    "notEntered": "尚未輸入",
    "outOfRange": "請輸入 {{min}} 至 {{max}} 之間的數值。",
    "saveFailed": "無法儲存。",
    "saved": "已儲存。",
    "save": "儲存此隊"
  },
  "scoreBreakdown": {
    "title": "成績明細（依來源）",
    "sourceJudge": "評審",
    "sourceStaff": "工作人員輸入",
    "pending": "未完成",
    "history": "修改紀錄（{{count}} 筆）",
    "revision": "{{time}}，{{name}} 將「{{field}}」由 {{from}} 改為 {{to}}",
    "none": "無"
  }
}
